// Reference: https://mui.com/material-ui/customization/theming/

import * as customComponents from "./componentCustomizations";

export const themeGlobal = {
	components: { ...customComponents },
	palette: {
		common: {
			black: "#333",
			white: "#fff",
		},
		primary: {
			main: "#6138f5",
			contrastText: "#fff",
		},
		secondary: {
			main: "#5B5B5B",
			contrastText: "#ffffff",
		},
		error: {
			main: "#F15060",
			contrastText: "#fff",
		},
		warning: {
			main: "#fa9f47",
			contrastText: "#ffffff",
		},
		info: {
			main: "#007cf0",
			contrastText: "#fff",
		},
		success: {
			main: "#2c856b",
			contrastText: "#fff",
		},
	},
	typography: {
		fontFamily: "Circular",
		fontSize: 22,
		fontWeightRegular: 300,
		button: {
			textTransform: "none",
		},
	},
	shape: {
		borderRadius: 6,
	},
	zIndex: {
		mobileStepper: 100000,
		fab: 105000,
		speedDial: 105000,
		appBar: 110000,
		drawer: 120000,
		modal: 130000,
		snackbar: 140000,
		tooltip: 150000,
	},
};
